/* eslint-disable react-hooks/exhaustive-deps */

import { useCallback, useEffect, useMemo, useRef } from 'react'

type Destructor = ReturnType<React.EffectCallback>

const useSynchronousEffect: typeof useEffect = (effect, dependencies) => {
  const cleanupRef = useRef<Destructor>()
  const performCleanup = useCallback(() => {
    if (cleanupRef.current) {
      cleanupRef.current()
    }
  }, [])

  useMemo(() => {
    performCleanup()
    cleanupRef.current = effect()
  }, dependencies)

  useEffect(() => {
    return cleanupRef.current
  }, [])
}

export default useSynchronousEffect
